import { render, staticRenderFns } from "./subSystem.vue?vue&type=template&id=6f36a33a&scoped=true&"
import script from "./subSystem.vue?vue&type=script&lang=ts&"
export * from "./subSystem.vue?vue&type=script&lang=ts&"
import style0 from "./subSystem.vue?vue&type=style&index=0&id=6f36a33a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f36a33a",
  null
  
)

export default component.exports